module.exports = __webpack_public_path__ + "img/null_data.8ad6fc19.png";